module.exports = __webpack_public_path__ + "media/images/svg-icon/notifications-b87da1ceacf1d8eaaf80e08ba9021953.svg";